import React from 'react';
import PropTypes from 'prop-types';

import { CONNECT_STATUS } from 'constants/profile';

import './styles.css';

const ListItemStatus = ({
  status,
  onClickConnectHandler,
  onClickMessageHandler,
  onClickAcceptHandler,
  onClickRejectHandler,
}) => {
  return (
    <>
      {
        {
          [CONNECT_STATUS.NOT_CONNECTED]: (
            <span className="list-item-status" onClick={onClickConnectHandler}>
              Connect
            </span>
          ),
          [CONNECT_STATUS.REQUIRE_APPROVE]: (
            <span className="list-item-status list-item-status--pending">
              Pending
            </span>
          ),
          [CONNECT_STATUS.CONNECTED]: (
            <span
              className="list-item-status list-item-status--message"
              onClick={onClickMessageHandler}
            >
              Message
            </span>
          ),
          [CONNECT_STATUS.REQUIRE_ACTION]: (
            <div>
              <span
                className="list-item-status list-item-status--accept"
                onClick={onClickAcceptHandler}
              >
                Accept
              </span>
              <span
                className="list-item-status list-item-status--reject"
                onClick={onClickRejectHandler}
              >
                Reject
              </span>
            </div>
          ),
        }[status]
      }
    </>
  );
};

ListItemStatus.defaultProps = {
  onClickConnectHandler: () => {},
  onClickMessageHandler: () => {},
  onClickAcceptHandler: () => {},
  onClickRejectHandler: () => {},
};

ListItemStatus.proptTypes = {
  status: PropTypes.oneOf([
    CONNECT_STATUS.CONNECTED,
    CONNECT_STATUS.NOT_CONNECTED,
    CONNECT_STATUS.REQUIRE_ACTION,
    CONNECT_STATUS.REQUIRE_APPROVE,
  ]).isRequired,
  onClickConnectHandler: PropTypes.func.isRequired,
  onClickMessageHandler: PropTypes.func.isRequired,
  onClickAcceptHandler: PropTypes.func.isRequired,
  onClickRejectHandler: PropTypes.func.isRequired,
};

export default ListItemStatus;
